module.exports = __webpack_public_path__ + "static/media/mvpLocation.99e21b4e.svg";